import { LoggerOutput } from './logger-output';
// for datadogLogs
import { EnvConfigService } from '@services/env-config.service';

export class DataDogLoggerOutput implements LoggerOutput {
  datadogLogs: any;
  datadogRum: any;
  isdatadogLogsInit = false;
  localEnv = 'novalue';

  constructor(private envConfig: EnvConfigService, private channel: string) {}

  initDataDog() {
    // Prepare environment specific info
    if (this.envConfig.getEnvConfig()) {
      this.localEnv = this.envConfig.getEnvConfig().environment;
    }

    if (!this.channel) {
      this.channel = 'novalue';
    }
    // Only loads libraries if token is present in config
    if (this.envConfig.getEnvConfig()?.datadogToken) {
      // Dynamic import rum lib
      import(/* webpackChunkName: "datadog" */ '@datadog/browser-rum').then(
        (browserRumModule) => {
          this.datadogRum = browserRumModule.datadogRum;
        }
      );
      // Dynamic import logs lib
      import(/* webpackChunkName: "datadog" */ '@datadog/browser-logs').then(
        (browserLogsModule) => {
          this.datadogLogs = browserLogsModule.datadogLogs;
          this.datadogLogs?.init({
            clientToken: this.envConfig.getEnvConfig().datadogToken,
            site: this.envConfig.getEnvConfig().datadogSite,
            service: this.envConfig.getEnvConfig().datadogService,
            env: this.localEnv,
            forwardErrorsToLogs: false,
            sampleRate: 100,
          });

          this.datadogLogs?.addLoggerGlobalContext('channel', this.channel);

          // Set the init flag
          this.isdatadogLogsInit = true;
        }
      );
    }
  }

  getLogger() {
    if (!this.isdatadogLogsInit) {
      this.initDataDog();
    }
    return this.datadogLogs?.logger;
  }

  debug(...data: any) {
    this.getLogger()?.debug(data);
  }

  info(...data: any) {
    this.getLogger()?.info(data);
  }

  warn(...data: any) {
    this.getLogger()?.warn(data);
  }

  error(...data: any) {
    this.getLogger()?.error(data);
    this.datadogRum?.addError(data);
  }

  exception(...data: any) {
    // TODO
    this.datadogRum?.addError(data);
  }

  event(...data: any) {
    // TODO
  }
}
